'use client';
import { useRef } from 'react';

export function useFocusLink() {
    const htmlElRef = useRef<HTMLAnchorElement>(null);
    const setFocus = () => {
        if (!htmlElRef) return;
        htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus] as const;
}
export default useFocusLink;
